import iccMarketService from '@/services/icc/iccMarketService';
import {selectGigyaToken} from '@/state/selectors/auth';
import {selectConsumerEmail, selectConsumerName} from '@/state/selectors/consumer';
import {getState} from '@/state/store';

const getAutoDeliveryConsumerData = async () => {
    let state = getState();
    let consumerName = selectConsumerName(state);
    let consumerEmail = selectConsumerEmail(state);
    const gigyaToken = selectGigyaToken(state);

    if (consumerName && consumerEmail) {
        return {consumerName, consumerEmail, gigyaToken};
    }

    await iccMarketService.getExternalConsumerProfile(gigyaToken);

    state = getState();
    consumerName = selectConsumerName(state);
    consumerEmail = selectConsumerEmail(state);

    if (consumerName && consumerEmail) {
        return {consumerName, consumerEmail, gigyaToken};
    }

    throw new Error('Failed to get external consumer profile data');
};

const deliverAsap = async ({asapDeliveryDate, onSuccess, onError}) => {
    try {
        if (asapDeliveryDate) {
            const response = await iccMarketService.deliverAsap(asapDeliveryDate);

            if (isSuccess(response?.data)) {
                onSuccess?.(response.data);
                return;
            } else {
                const errorMessage = getErrorMessage(response);

                onError?.(errorMessage);
            }
        }
    } catch (e) {
        const errorMessage = getErrorMessage(e);

        onError?.(errorMessage);
        return;
    }
    const errorMessage = 'ASAP Delivery Date has not provided';

    onError?.(errorMessage);
};

const skipAutoDeliveryDcx = async ({onSuccess, onError}) => {
    try {
        const {consumerName, consumerEmail, gigyaToken} = await getAutoDeliveryConsumerData();

        const response = await iccMarketService.skipAutoDeliveryDcx({
            consumerName,
            consumerEmail,
            gigyaToken,
        });

        if (isSuccess(response?.data)) {
            onSuccess?.(response.data);
            return;
        } else {
            const errorMessage = getErrorMessage(response);

            onError?.(errorMessage);
        }
    } catch (e) {
        const errorMessage = getErrorMessage(e);

        onError?.(errorMessage);
    }
};

const rescheduleDelivery = async ({startDate, frequency, onSuccess, onError}) => {
    try {
        const {consumerName, consumerEmail, gigyaToken} = await getAutoDeliveryConsumerData();

        const response = await iccMarketService.rescheduleAutoDeliveryDcx({
            consumerName,
            consumerEmail,
            gigyaToken,
            startDate,
            frequency,
        });

        if (isSuccess(response?.data)) {
            onSuccess?.(response.data);
            return;
        } else {
            const errorMessage = getErrorMessage(response);

            onError?.(errorMessage);
        }
    } catch (e) {
        const errorMessage = getErrorMessage(e);

        onError?.(errorMessage);
    }
};

const isSuccess = (data) => {
    if (!data) return false;

    const {serviceError} = data;

    if (serviceError) return false;

    return true;
};

const getErrorMessage = (e) => {
    const serverErrorMessage = e?.data
        ? e?.data?.serviceError?.message?.value
        : e?.response?.data?.serviceError?.message?.value;

    const defaultErrorMessage = 'Error has not provided by the backend';

    return serverErrorMessage ? serverErrorMessage : e?.message ? e.message : defaultErrorMessage;
};

export default {deliverAsap, skipAutoDeliveryDcx, rescheduleDelivery};
